<template>
  <Modal width="500" v-model="dialogVisible" class-name="vertical-center-modal" dialogType="dialog">
    <div slot="header" class="header-slot">
      登录
    </div>
    <form class="login-form">
      <div class="login-title">欢迎登录</div>
      <div class="form-group">
        <div class="controls">
          <div class="input-div">
            <!--<input type="text" autocomplete="off" class="form-control" v-model="username" placeholder="已注册的手机号或用户名">-->
            <Input type="text" autocomplete="off" v-model="username" placeholder="已注册的手机号或用户名"></Input>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="controls">
          <div class="input-div">
            <!--<input type="password" autocomplete="off" class="form-control" v-model="password" placeholder="登录密码">-->
            <Input type="password" autocomplete="off" v-model="password" placeholder="登录密码"></Input>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="controls">
          <button type="button" class="btn-login" @click="submitData">登录</button>
        </div>
      </div>
      <div class="form-group login-tip">
        还没有账号？<span class="register" @click="routerTo">免费注册</span>
      </div>
    </form>
    <Dialog width="300px" :visible.sync="dialogTipVisible" :message="tip_msg"  dialogType="message"></Dialog>
    <div slot="footer">

    </div>
  </Modal>
</template>
<script>

import Dialog from '@/components/Dialog'
import { Modal, FormItem, Input } from 'view-design'
export default {
  name: 'Login',
  components: {
    Dialog,
    Modal,
    FormItem,
    Input
  },
  props: {
    isNeedLogin: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      username: undefined,
      password: undefined,
      dialogVisible: this.isNeedLogin,
      dialogTipVisible: false,
      tip_msg: undefined
    }
  },
  watch: {
    isNeedLogin(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      if (val) {
        this.username = undefined
        this.password = undefined
        this.dialogTipVisible = false
        this.tip_msg = undefined
      }
      this.$emit('change', val)
    }
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown, true)// 开启监听键盘按下事件
  },
  methods: {
    handleKeyDown(e) {
      let key = null
      if (window.event === undefined) {
        key = e.keyCode
      } else {
        key = window.event.keyCode
      }
      if (key === 13) {
        this.submitData()
      }
    },
    submitData() {
      if (this.isLock()) {
        return;
      }
      this.lock();
      this.vaildForm().then(valid => {
        if (valid) {
          setTimeout(()=>{
            this.loading = false
            this.unlock()
            this.$emit('login', 1)
            this.message('登录成功')
            setTimeout(()=>{
              this.dialogVisible = false
            }, 1000)
          }, 1500)
        } else {
          this.unlock();
        }
      })
    },
    lock() {
      this.isDoing = true;
    },
    unlock() {
      this.isDoing = false;
    },
    isLock() {
      return this.isDoing
    },
    // 校验登录
    async vaildForm() {
      this.tip_msg = undefined
      this.dialogTipVisible = false
      if(!this.username || this.username === '') {
        this.tip_msg = '用户名不能为空'
      } else if (!this.password || this.password === ''){
        this.tip_msg = '密码不能为空'
      }
      if (this.tip_msg) {
        this.message(this.tip_msg)
        return false
      } else {
        return true
      }
    },
    // 文本提示
    message(msg){
      this.tip_msg = msg
      this.dialogTipVisible = true
    },
    // 免费注册
    routerTo() {
      this.$router.push('/register').catch(err => { err })
    }
  }
}
</script>
<style scoped>
.header-slot{
  display: inline-block;
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  /*color: #17233d;*/
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color:#fff;
}
>>>.ivu-modal-header{
  background: #199ED8;
  border-top-left-radius:6px;
  border-top-right-radius:6px;
}
>>> .ivu-icon-ios-close{
  display: flex;
  align-items: center;
  font-size:16px;
  height: 31px;
  top: 0;
}
>>> .ivu-icon-ios-close:before {
  content:'关闭';
  color:#fff;
}
>>>.ivu-modal-footer{
  border-top:none;
}
>>>.vertical-center-modal{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
>>>.vertical-center-modal .ivu-modal{
  top: 0;
}
.login-form{
  margin-top: 50px;
}
.login-title{
  text-align: center;
  margin: 15px auto 25px;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.form-group{
  position: relative;
  overflow: hidden;
  margin: auto;
  width: 60%;
  text-align: center;
}
.form-group::before,.form-group::after{
  content: " ";
  display: table;
  box-sizing: border-box;
}
.controls{
  overflow: hidden;
  margin-bottom: 15px;
}
.input-div {
  float: left;
  width: 100%;
}
.form-control {
  border-color: #666666;
  height: 33px;
  box-shadow: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  padding: 6px 12px;
  font-size: 12px;
  line-height: 1.42857143;
  color: #555555;
  background-color: #fff;
  border: 1px solid #ccc;
}
input{
  font: inherit;
  margin: 0;
}
.btn-login{
  border-radius: 4px;
  background: #199ED8;
  color: #FFFFFF;
  padding: 10px 70px;
  font-size: 15px;
  line-height: 1.3333333;
  margin-top: 20px;
  cursor: pointer;
}
.login-tip {
  position: relative;
  top: 2px;
  color: #999999;
}
.login-tip .register{
  color: rgba(255, 102, 0, 0.898039215686275);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/document/user/Login.vue